export const clearsEmptyProperties = (obj: Record<string, any>) => {
  if (obj === null || typeof obj !== 'object') return obj

  const cleaned: Record<string, any> = {}

  for (const key in obj) {
    const value = obj[key]

    if (value === null || value === undefined || value === '') {
      continue
    }

    if (Array.isArray(value)) {
      const filtered = value
        .map((item) => clearsEmptyProperties(item))
        .filter((v: any) => v !== null && v !== undefined && v !== '')

      if (filtered.length > 0) {
        cleaned[key] = filtered
      }
      continue
    }

    if (typeof value === 'object') {
      const nested = clearsEmptyProperties(value)

      if (nested && Object.keys(nested).length > 0) {
        cleaned[key] = nested
      }

      continue
    }

    cleaned[key] = value
  }

  return cleaned
}
